import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {updateInitialDashboardSetting} from "../../../../../api/main/DashboardApi";

interface Props {
    closeCallback: () => any
}

export const useUpdateInitialDashboardSetting = ({closeCallback}: Props) => {
    const {handleModal} = useModal();
    const qc = useQueryClient();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: () => updateInitialDashboardSetting(),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "수정되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readDashboardSetting"]})
                        closeCallback()
                    }
                })
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
